import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSmokefree(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M6.899 5.516a8.25 8.25 0 0 1 11.585 11.586L15.883 14.5H17a.75.75 0 0 0 .75-.75v-3.5A.75.75 0 0 0 17 9.5h-6.117zm-1.09 1.031a8.25 8.25 0 0 0 11.644 11.644L13.762 14.5H7a.75.75 0 0 1-.75-.75v-3.5A.75.75 0 0 1 7 9.5h1.762zM7.75 11h2.512l2 2H7.75zm4.633 0 2 2h1.867v-2z",
    clipRule: "evenodd"
  }));
}
var IcSmokefree = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSmokefree));

export { IcSmokefree as I };
